import { createContext, useContext } from "react";

import { Theme } from "./theme_context_provider.types";

type ThemeContextType = {
  theme: Theme;
  changeTheme: (newTheme: Theme) => void;
  themes: Theme[];
  themeVars: Record<string, string>;
};

const DEFAULT_THEME_CONTEXT: ThemeContextType = {
  theme: Theme.Light,
  changeTheme: () => {},
  themes: [],
  themeVars: {}
};

export const ThemeContext = createContext<ThemeContextType>(DEFAULT_THEME_CONTEXT);

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return context;
};
